import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseDownstreamFlowsFilteredByTableQuery, DatabaseDownstreamFlowsFilteredByTableQueryVariables, DatabaseDownstreamFlowsQuery, DatabaseDownstreamFlowsQueryVariables, FlowsDisplayGridRowDataFragment, FlowSortOrder , DatabaseDownstreamFlowsFilteredByTableDocument , DatabaseDownstreamFlowsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import {
  FlowsDisplayGrid,
  FlowsDisplayGridRowData,
  getRowDataForFlow,
} from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = DatabaseDownstreamFlowsQueryVariables;
type QueryResults = DatabaseDownstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowDataFragment;
type GridRowData = FlowsDisplayGridRowData;

type QueryVariablesWithFilter = DatabaseDownstreamFlowsFilteredByTableQueryVariables;
type QueryResultsWithFilter = DatabaseDownstreamFlowsFilteredByTableQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databases && resultData.databases[0] &&
    resultData.databases[0].downstreamFlowsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] &&
    resultData.tables[0].downstreamFlowsConnection;
}

export type DatabaseDownstreamFlowsQueryGridProps = GridSortProps<FlowsValidSortFields> & {
  readonly databaseId: string;
  readonly filteredTableId: string | null;
  readonly rowCount: number | null;
};

export function DatabaseDownstreamFlowsQueryGrid(props: DatabaseDownstreamFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamFlowsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredFlowsLineageGridMessage();

  return (
    props.filteredTableId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={DatabaseDownstreamFlowsFilteredByTableDocument}
        partialQueryVariables={{ tableId: props.filteredTableId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) =>
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatabaseDownstreamFlowsDocument}
        partialQueryVariables={{ databaseId: props.databaseId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) =>
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    )
  )
}
